import React, { useEffect, useState } from 'react';
import Cookie from 'js-cookie';
import { BASE_URL } from '../../config/constants';
import { useTranslation } from 'react-i18next';
const AddUserSubscription = () => {
	const { t } = useTranslation();
	const [searchEmail, setSearchEmail] = useState('');
	const [users, setUsers] = useState([]);
	const [selectedUser, setSelectedUser] = useState(null);
	const [actionType, setActionType] = useState('buy');
	const [courses, setCourses] = useState([]);
	const [selectedCourse, setSelectedCourse] = useState('');
	const [endDate, setEndDate] = useState('');
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState('');
	const baseUrl = BASE_URL;
	const getUsers = async (email) => {
		try {
			setLoading(true);
			const token = Cookie.get('token');
			const response = await fetch(
				`${baseUrl}/api/v1/users?filters=${encodeURIComponent(
					JSON.stringify({ email })
				)}`,
				{
					headers: {
						Authorization: `Bearer ${token}`,
						accept: 'application/json',
					},
				}
			);
			const data = await response.json();
			setUsers(data.data);
		} catch (err) {
			setError('Failed to fetch users');
		} finally {
			setLoading(false);
		}
	};

	const getCourses = async () => {
		try {
			setLoading(true);
			const token = Cookie.get('token');
			const response = await fetch(
				`${baseUrl}/api/v1/courses?limit=1000&filters=%7B%22paymentType%22%3A%22BY_COURSE%22%7D`,
				{
					headers: {
						Authorization: `Bearer ${token}`,
						accept: '*/*',
					},
				}
			);
			const data = await response.json();
			setCourses(data);
		} catch (err) {
			setError('Failed to fetch courses');
		} finally {
			setLoading(false);
		}
	};

	const handleBuyCourse = async () => {
		try {
			console.log(selectedUser.id, selectedCourse);
			const token = Cookie.get('token');
			await fetch(`${baseUrl}/api/v1/my-learning/create`, {
				method: 'POST',
				headers: {
					Authorization: `Bearer ${token}`,
					'Content-Type': 'application/json',
					accept: '*/*',
				},
				body: JSON.stringify({
					userId: selectedUser.id,
					courseId: parseInt(selectedCourse, 10),
				}),
			});
			alert('Course purchased successfully!');
		} catch (err) {
			setError('Failed to purchase course');
		}
	};

	const handleRenewSubscription = async () => {
		try {
			const token = Cookie.get('token');
			await fetch(`${baseUrl}/api/v1/subscriptions`, {
				method: 'POST',
				headers: {
					Authorization: `Bearer ${token}`,
					'Content-Type': 'application/json',
					accept: '*/*',
				},
				body: JSON.stringify({
					userId: selectedUser.id,
					startDate: new Date().toISOString(),
					endDate: new Date(endDate).toISOString(),
					transactionId: 1,
				}),
			});
			alert('Subscription renewed successfully!');
		} catch (err) {
			setError('Failed to renew subscription');
		}
	};

	const handleSubmit = (e) => {
		e.preventDefault();
		if (actionType === 'buy') {
			handleBuyCourse();
		} else {
			handleRenewSubscription();
		}
	};

	useEffect(() => {
		if (searchEmail.length > 3) {
			const debounceTimer = setTimeout(() => {
				getUsers(searchEmail);
			}, 500);
			return () => clearTimeout(debounceTimer);
		}
	}, [searchEmail]);

	useEffect(() => {
		if (actionType === 'buy' && selectedUser) {
			getCourses();
		}
	}, [actionType, selectedUser]);

	return (
		<div
			className='container mt-40 max-w-7xl'
			style={{
				border: '2px solid black',
				padding: '20px',
				borderRadius: '10px',
			}}>
			<h2 style={{ color: 'black', fontSize: '24px', marginBottom: '20px' }}>
				{t('manageSubscriptions')}
			</h2>

			<div
				className='search-section'
				style={{ marginBottom: '20px' }}>
				<label
					htmlFor='searchEmail'
					style={{ color: 'black', marginBottom: '5px', display: 'block' }}>
					{t('userEmail')}
				</label>
				<input
					id='searchEmail'
					type='email'
					placeholder='Search user by email'
					value={searchEmail}
					onChange={(e) => setSearchEmail(e.target.value)}
					style={{
						color: 'black',
						padding: '10px',
						width: '25%',
						border: '1px solid black',
						borderRadius: '5px',
					}}
				/>
				{loading && (
					<p style={{ color: 'black', marginTop: '10px' }}>Loading...</p>
				)}
				{users.length > 0 && (
					<div
						className='user-list'
						style={{ marginTop: '10px' }}>
						<h3 style={{ color: 'black', marginBottom: '10px' }}>Users:</h3>
						{users.map((user) => (
							<div
								key={user.id}
								className={`user-item ${
									selectedUser && selectedUser.id === user.id ? 'selected' : ''
								}`}
								onClick={() => setSelectedUser(user)}
								style={{
									color: 'black',
									cursor: 'pointer',
									padding: '10px',
									border: '1px solid black',
									margin: '5px 0',
									borderRadius: '5px',
									backgroundColor:
										selectedUser && selectedUser.id === user.id
											? 'var(--secondary-color)'
											: 'white',
								}}
								onMouseEnter={(e) =>
									(e.currentTarget.style.backgroundColor = 'var(--main-color)')
								}
								onMouseLeave={(e) =>
									(e.currentTarget.style.backgroundColor =
										selectedUser && selectedUser.id === user.id
											? 'var(--secondary-color)'
											: 'white')
								}>
								{user.email}
							</div>
						))}
					</div>
				)}
			</div>

			{selectedUser && (
				<form
					onSubmit={handleSubmit}
					className='mt-20'>
					<div
						className='action-select'
						style={{ marginBottom: '20px' }}>
						<label style={{ color: 'black', marginRight: '10px' }}>
							<input
								type='radio'
								value='buy'
								checked={actionType === 'buy'}
								onChange={() => setActionType('buy')}
								style={{ marginRight: '5px' }}
							/>
							Buy Course
						</label>
						<label style={{ color: 'black' }}>
							<input
								type='radio'
								value='renew'
								checked={actionType === 'renew'}
								onChange={() => setActionType('renew')}
								style={{ marginRight: '5px' }}
							/>
							Renew Subscription
						</label>
					</div>

					{actionType === 'buy' ? (
						<div
							className='course-select'
							style={{ marginBottom: '20px' }}>
							<select
								value={selectedCourse}
								onChange={(e) => setSelectedCourse(e.target.value)}
								required
								style={{
									color: 'black',
									padding: '10px',
									width: '50%',
									border: '1px solid black',
									borderRadius: '5px',
								}}>
								<option value=''>Select a course</option>
								{courses.map((course) => (
									<option
										key={course.id}
										value={course.id}>
										{course.name}
									</option>
								))}
							</select>
						</div>
					) : (
						<div
							className='date-input'
							style={{ marginBottom: '20px' }}>
							<label
								style={{
									color: 'black',
									marginBottom: '5px',
									display: 'block',
								}}>
								Subscription End Date:
							</label>
							<input
								type='datetime-local'
								value={endDate}
								onChange={(e) => setEndDate(e.target.value)}
								required
								style={{
									color: 'black',
									padding: '10px',
									width: '50%',
									border: '1px solid black',
									borderRadius: '5px',
								}}
							/>
						</div>
					)}

					{error && (
						<p
							className='error'
							style={{ color: 'black', marginBottom: '20px' }}>
							{error}
						</p>
					)}
					<button
						type='submit'
						disabled={loading}
						style={{
							color: 'black',
							padding: '10px 20px',
							border: '1px solid black',
							borderRadius: '5px',
						}}>
						{loading ? 'Processing...' : 'Submit'}
					</button>
				</form>
			)}
		</div>
	);
};

export default AddUserSubscription;
